import React from "react";
import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

const Root = styled('div')(({ theme }) => ({
  width: '100%',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  height: "80%",
  minHeight: "250px",
  minWidth: "165px",
  maxWidth: "400px",
  maxHeight: "300px",
  textAlign: "center",
  padding: theme.spacing(2),
  margin: "auto",
  marginTop: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  backgroundColor: "#2ec4b6",
  fontFamily: "Helvetica Inserat",
  fontSize: "3em",
  color: "white",
  textShadow: "4px 4px 2px #000000",
}));

const FinalCategoryCell = React.forwardRef(({ label, onClick, ...props }, ref) => {
  return (
    <Root>
      <StyledPaper {...props} onClick={onClick} ref={ref}>
        {label.toUpperCase()}
      </StyledPaper>
    </Root>
  );
});

export default FinalCategoryCell;
